export default "__VITE_ASSET__D59WDPke__"